import "./Pill.scss";
import { OrderStatusEnum } from "../../types/OrderStatusEnum";

interface Props {
  status: OrderStatusEnum;
}

export const Pill = ({ status }: Props) => {
  const getClass = (orderStatus: OrderStatusEnum) => {
    switch (orderStatus) {
      case OrderStatusEnum.PENDIENTE:
        return "pill-pending";
      case OrderStatusEnum.PROCESSO:
        return "pill-processing";
      case OrderStatusEnum.TERMINADO:
        return "pill-ended";
      case OrderStatusEnum.ENTREGADO:
        return "pill-delivered";
      default:
        return "pill";
    }
  };

  const getText = (orderStatus: OrderStatusEnum) => {
    switch (orderStatus) {
      case OrderStatusEnum.PENDIENTE:
        return "Pendiente";
      case OrderStatusEnum.PROCESSO:
        return "En Proceso";
      case OrderStatusEnum.TERMINADO:
        return "Terminado";
      case OrderStatusEnum.ENTREGADO:
        return "Entregado";
      default:
        return "";
    }
  };

  return <div className={getClass(status)}>{getText(status)}</div>;
};
